import {useTranslation} from "react-i18next";
import Form from 'react-bootstrap/Form';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";



const FormParams = (props) => {
    const [tF] = useTranslation("forms");


    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <h4>Parametros</h4>
                    <h5>{props.plugSelected.name}</h5>
                </div>
            </div>
            <div className="row">
                <div className="m-auto col-md-8 col-12">
                    <Form onSubmit={props.submitParams}>
                        {Object.keys(props.plugSelected.params).map((param, idx) => (
                            <Form.Group as={Row} className="mb-3" controlId="formHorizontalPassword" key={idx}>
                                <Form.Label column sm={2}>
                                    {tF(props.plugSelected.params[param].label)}
                                </Form.Label>
                                <Col sm={10}>
                                    <Form.Control type={props.plugSelected.params[param].type} name={param} onChange={props.onChangeParams} required={props.plugSelected.params[param].required}/>
                                </Col>
                            </Form.Group>
                        ))}
                        <div className="col-12 text-end">
                            <button type="submit" className="btn btn-primary btn-sm">Guardar</button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
}

export default FormParams

